<template>
  <v-container
    id="marketing-contact-dashboard-view"
    class="index-page-alignment"
    fluid
  >
    <v-row>
      <v-col class="index-breadcrumb-alignment">
        <v-breadcrumbs
          class="mr-0 pa-0"
          :items="breadcrumbsList"
        >
          <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
          <template v-slot:item="{item}">
            <li>
              <span v-if="item.disabled">{{ item.text }}</span>
              <router-link
                v-else-if="item.listId"
                :to="{name: item.path, params: { id: item.listId } }"
              >
                {{ item.text }}
              </router-link>
              <router-link
                v-else
                :to="{name: item.path }"
              >
                {{ item.text }}
              </router-link>
            </li>
          </template>
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="12"
        lg="4"
      >
        <v-row>
          <v-col cols="12" class="px-0 pt-0">
            <contact-info
              :loading="infoLoader"
              :contact-id="contactId"
              @getContactInfo="getContactInfo"
            />
            <contact-tags
              v-if="contactId"
              :contact-id="contactId"
              :contact="contactInfo.email"
            />
            <contact-lists
              v-if="contactId"
              :contact-id="contactId"
              :contact="contactInfo.email"
            />
            <contact-brands
              v-if="contactId"
              :contact-id="contactId"
              :contact="contactInfo.email"
            />
            <ContactRFMGroup
              v-if="contactId && isERFMEnable"
              :contact-id="contactId"
            />
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        md="12"
        lg="8"
        sm="12"
      >
        <v-tabs
          v-model="activeTab"
          height="48"
          background-color="grey lighten-5"
          color="#03b6fc"
          class="contact-dashboard-tabs"
          show-arrows
        >
          <v-tab
            v-for="tab in dashboardTabs"
            :id="tab.uniqueId"
            :key="tab.id"
            :href="tab.href"
            :disabled="infoLoader"
            exact
            class="contact-dashboard-tab px-8"
          >
          <span class="body-2 d-flex font-weight-regular tab-heading">
              {{ tab.name }}
              <div v-if="tab.count > 0" class="d-flex align-center px-2">
                {{ `(${tab.count})` }}
              </div>
            </span>
          </v-tab>
        </v-tabs>
        <v-divider />
        <v-tabs-items
          v-model="activeTab"
          style="background:#fafafa"
        >
          <v-tab-item
            v-for="tab in dashboardTabs"
            :key="tab.id"
            :value="tab.uniqueId"
            :transition="false"
            :reverse-transition="false"
          >
            <component
              :is="tab.component"
              :contact-info="contactInfo"
              :info-loader="infoLoader"
              :current-account="currentAccount"
              @countEvent="handleCountData"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ContactInfo from './ContactInfo.vue'
import ContactTags from './ContactTags.vue'
import ContactLists from './ContactLists.vue'
import ContactBrands from './ContactBrands.vue'
import Overview from './Overview'
import Campaigns from '../components/Campaigns'
import Tickets from '../components/Tickets'
import Orders from '../components/Orders'
import AbandonedCarts from '../components/AbandonedCarts'
import { mapGetters } from "vuex"
import ContactRFMGroup from './ContactRFMGroup.vue'

export default {
  name: "contact-dashboard",
  components: {
    ContactInfo,
    ContactTags,
    ContactLists,
    ContactBrands,
    Overview,
    Campaigns,
    Tickets,
    Orders,
    AbandonedCarts,
    ContactRFMGroup
  },
  data() {
    return {
      breadcrumbsList: [
        {
          text: "Contacts",
          disabled: false,
          path: "List_contacts",
        },
        {
          text: "Dashboard",
          disabled: false,
          path: "",
        },
      ],
      contactId: null,
      activeTab: 'overview',
      dashboardTabs: [],
      contactInfo: {},
      infoLoader: false,

    };
  },
  computed: {
    ...mapGetters({
      currentAccount: 'auth/account.current',
      packageFeatures: 'auth/packageFeatures',
    }),
    isERFMEnable () {
      const packageFeatures = this.packageFeatures.account_setting
      return packageFeatures && packageFeatures.erfm_enabled 
    }
  },
  mounted() {
    this.contactId = this.$route.params.contactId
    let listID = this.$route.params.listId
    this.breadcrumbsList[0].path = (listID) ? 'List_contacts' : 'Dashboard'
    this.breadcrumbsList[0].listId = (listID) ? listID : ''
    this.infoLoader = true
    this.dashboardTabs = [
      {
        id: 1,
        uniqueId: 'overview',
        name: 'OVERVIEW',
        href: '#overview',
        component: 'Overview',
        count: 0,
        access: true
      },
      {
        id: 2,
        uniqueId: 'campaigns',
        name: 'CAMPAIGNS',
        href: '#campaigns',
        component: 'Campaigns',
        count: 0,
        access: this.currentAccount.enable_marketing
      },
      {
        id: 3,
        uniqueId: 'tickets',
        name: 'TICKETS',
        href: '#tickets',
        component: 'Tickets',
        count: 0,
        access: this.currentAccount.enable_service && this.$can('read','contacts')
      },
      {
        id: 4,
        uniqueId: 'orders',
        name: 'ORDERS',
        href: '#orders',
        component: 'Orders',
        count: 0,
        access: true
      },
      {
        id: 5,
        uniqueId: 'abandoned-carts',
        name: 'Abandoned Cart List',
        href: '#abandoned-carts',
        component: 'AbandonedCarts',
        count: 0,
        access: this.currentAccount.enable_marketing
      },
    ]
    this.dashboardTabs = this.dashboardTabs.filter((tab) => tab.access)
  },
  methods: {
    getContactInfo (value) {
      // Update Breadcrumbs
      this.breadcrumbsList.splice(1, 1)
      this.breadcrumbsList.push({
        text: value.name,
        disabled: true,
      })
      // Get Email
      this.contactInfo = value
      this.infoLoader = false
    },
    /**
    * update the Tab badge data count
    */
    handleCountData (data) {
      if (this.currentAccount.enable_marketing
        && this.currentAccount.enable_service
        && this.$can('read','contacts')
      ) {
        this.dashboardTabs[1].count = data.count.campaigns
        this.dashboardTabs[2].count = data.count.tickets
        this.dashboardTabs[3].count = data.count.orders
        this.dashboardTabs[4].count = data.count.abCarts
      } else if (this.currentAccount.enable_marketing) {
        this.dashboardTabs[1].count = data.count.campaigns
        this.dashboardTabs[2].count = data.count.orders
        this.dashboardTabs[3].count = data.count.abCarts
      } else {
        this.dashboardTabs[1].count = data.count.tickets
      }
    },
  },
};
</script>
<style lang="scss">
#marketing-contact-dashboard-view {
  .v-tab {
    padding: 0 28px;
    .tab-heading {
      color: #484848;
    }
  }
  .v-tab--active .tab-heading {
    color: #03b6f9;
  }
  .data-count {
    background: #727272;
    border-radius: 11px;
    margin-left: 5px;
    font-family: "Montserrat", sans-serif !important;
    align-items: center;
    height: 20px;
    color: #FFFFFF;
  }
  .mdi-chevron-left:hover{
    border-radius: 50%;
    background-color:#F0F0F0;
  }
  .mdi-chevron-right:hover{
    border-radius: 50%;
    background-color: #F0F0F0;
  }
  .marketing-padding-fix {
    padding: 16px 24px 16px 24px !important;
  }
}
</style>
